// ─── CCFS Leads constants — extracted from AdminCCFSLeads.jsx (Phase 1) ───
// Pure static data. No behaviour change.

export const CASE_TYPES = ['CLOSE_DIRECT', 'CLOSE_WITH_FILINGS', 'CONTINUE_FIX', 'COMPLEX'];

export const COMPLEXITIES = ['Simple', 'Moderate', 'Complex'];

export const PIPELINE_STAGES = [
  { key: 'enquiry', label: 'Enquiry' },
  { key: 'mca_master', label: 'MCA Master' },
  { key: 'filing_index', label: 'Filing Index' },
  { key: 'eligibility_check', label: 'Eligibility Check' },
  { key: 'intent_call', label: 'Intent Call' },
  { key: 'bs_analysed', label: 'BS Analysed' },
  { key: 'detailed_report', label: 'Detailed Report' },
  { key: 'discovery_call', label: 'Discovery Call' },
  { key: 'proposal', label: 'Proposal' },
  { key: 'won', label: 'Won' },
  { key: 'dropped', label: 'Dropped' },
];

export const PIPELINE_COLORS = {
  enquiry: 'bg-slate-500',
  mca_master: 'bg-blue-500',
  filing_index: 'bg-indigo-500',
  eligibility_check: 'bg-violet-500',
  quick_report: 'bg-cyan-500',
  intent_call: 'bg-sky-500',
  bs_analysed: 'bg-purple-500',
  discovery_call: 'bg-fuchsia-500',
  detailed_report: 'bg-amber-500',
  proposal: 'bg-orange-500',
  won: 'bg-green-600',
  dropped: 'bg-red-500',
};

export const CASE_TYPE_COLORS = {
  CLOSE_DIRECT: 'bg-red-100 text-red-700 border-red-200',
  CLOSE_WITH_FILINGS: 'bg-orange-100 text-orange-700 border-orange-200',
  CONTINUE_FIX: 'bg-green-100 text-green-700 border-green-200',
  COMPLEX: 'bg-purple-100 text-purple-700 border-purple-200',
};

export const COMPLEXITY_COLORS = {
  Simple: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  Moderate: 'bg-amber-100 text-amber-700 border-amber-200',
  Complex: 'bg-red-100 text-red-700 border-red-200',
};

export const STATUS_MAP = {
  closed: { label: 'Business Stopped', color: 'bg-red-50 text-red-600 border-red-200' },
  running: { label: 'Business Active', color: 'bg-green-50 text-green-600 border-green-200' },
};

export const INTENT_MAP = {
  close: { label: 'Close Company', color: 'bg-red-50 text-red-600 border-red-200' },
  continue: { label: 'Continue Business', color: 'bg-green-50 text-green-600 border-green-200' },
};

// ─── BS / P&L line items (used by BSAnalysisPanel + StructuredCallNotes) ───
export const BS_LINE_ITEMS = [
  // EQUITY & LIABILITIES
  { key: 'share_capital', label: '(a) Share Capital', section: 'equity_liab', group: '1. Shareholders\' Funds', indent: 1 },
  { key: 'reserves', label: '(b) Reserves & Surplus', section: 'equity_liab', group: '1. Shareholders\' Funds', indent: 1 },
  { key: 'share_application', label: '2. Share Application Money Pending Allotment', section: 'equity_liab', group: '', indent: 0 },
  { key: 'long_term_borrowings', label: '(a) Long-term Borrowings', section: 'equity_liab', group: '3. Non-Current Liabilities', indent: 1 },
  { key: 'deferred_tax_liab', label: '(b) Deferred Tax Liabilities (Net)', section: 'equity_liab', group: '3. Non-Current Liabilities', indent: 1 },
  { key: 'other_long_term_liab', label: '(c) Other Long-term Liabilities', section: 'equity_liab', group: '3. Non-Current Liabilities', indent: 1 },
  { key: 'long_term_provisions', label: '(d) Long-term Provisions', section: 'equity_liab', group: '3. Non-Current Liabilities', indent: 1 },
  { key: 'short_term_borrowings', label: '(a) Short-term Borrowings', section: 'equity_liab', group: '4. Current Liabilities', indent: 1 },
  { key: 'trade_payables', label: '(b) Trade Payables', section: 'equity_liab', group: '4. Current Liabilities', indent: 1 },
  { key: 'other_current_liab', label: '(c) Other Current Liabilities', section: 'equity_liab', group: '4. Current Liabilities', indent: 1 },
  { key: 'short_term_provisions', label: '(d) Short-term Provisions', section: 'equity_liab', group: '4. Current Liabilities', indent: 1 },
  // ASSETS
  { key: 'tangible_assets', label: '(i) Tangible Assets', section: 'assets', group: '1. Non-Current Assets — (a) Fixed Assets', indent: 1 },
  { key: 'intangible_assets', label: '(ii) Intangible Assets', section: 'assets', group: '1. Non-Current Assets — (a) Fixed Assets', indent: 1 },
  { key: 'cwip', label: '(iii) Capital Work-in-Progress', section: 'assets', group: '1. Non-Current Assets — (a) Fixed Assets', indent: 1 },
  { key: 'noncurrent_investments', label: '(b) Non-Current Investments', section: 'assets', group: '1. Non-Current Assets', indent: 1 },
  { key: 'deferred_tax_asset', label: '(c) Deferred Tax Assets (Net)', section: 'assets', group: '1. Non-Current Assets', indent: 1 },
  { key: 'long_term_loans', label: '(d) Long-term Loans & Advances', section: 'assets', group: '1. Non-Current Assets', indent: 1 },
  { key: 'other_noncurrent_assets', label: '(e) Other Non-Current Assets', section: 'assets', group: '1. Non-Current Assets', indent: 1 },
  { key: 'current_investments', label: '(a) Current Investments', section: 'assets', group: '2. Current Assets', indent: 1 },
  { key: 'inventories', label: '(b) Inventories', section: 'assets', group: '2. Current Assets', indent: 1 },
  { key: 'trade_receivables', label: '(c) Trade Receivables', section: 'assets', group: '2. Current Assets', indent: 1 },
  { key: 'cash_bank', label: '(d) Cash & Cash Equivalents', section: 'assets', group: '2. Current Assets', indent: 1 },
  { key: 'short_term_loans', label: '(e) Short-term Loans & Advances', section: 'assets', group: '2. Current Assets', indent: 1 },
  { key: 'other_current_assets', label: '(f) Other Current Assets', section: 'assets', group: '2. Current Assets', indent: 1 },
];

export const PL_LINE_ITEMS = [
  { key: 'revenue_operations', label: 'I. Revenue from Operations', filings: 'GST returns (GSTR-1/3B), Sales register, Invoices' },
  { key: 'other_income', label: 'II. Other Income', filings: 'Interest certificates, TDS certificates (Form 26AS/AIS)' },
  { key: 'total_revenue', label: 'III. Total Revenue (I + II)', isTotal: true, filings: '' },
  { key: 'cost_materials', label: 'Cost of Materials Consumed', isExpense: true, filings: 'Purchase register, GST ITC reconciliation' },
  { key: 'purchases_stock', label: 'Purchases of Stock-in-Trade', isExpense: true, filings: 'Purchase invoices, Stock register' },
  { key: 'employee_expense', label: 'Employee Benefit Expense', isExpense: true, filings: 'PF challans, ESI challans, Payroll register, Form 16' },
  { key: 'finance_cost', label: 'Finance Costs', isExpense: true, filings: 'Bank loan statements, Interest certificates, CHG filings' },
  { key: 'depreciation', label: 'Depreciation & Amortisation', isExpense: true, filings: 'Fixed asset register, IT depreciation schedule' },
  { key: 'other_expenses', label: 'Other Expenses', isExpense: true, filings: 'Expense vouchers, Audit fees (ADT-1), Rent agreements' },
  { key: 'total_expenses', label: 'IV. Total Expenses', isTotal: true, filings: '' },
  { key: 'profit_before_tax', label: 'V. Profit/(Loss) Before Tax', isTotal: true, filings: 'IT computation, Advance tax challans' },
  { key: 'net_profit_loss', label: 'VIII. Profit/(Loss) for the Period', isTotal: true, filings: 'ITR filed, Tax demand notices, CPC orders' },
];

export const CLOSURE_PATHS = ['NIL', 'Write-off', 'Settle', 'Transfer', 'Liquidate', 'Collect', 'Repay', 'NOC Required', 'Board Resolution', 'Other'];
export const COMPLEXITY_LEVELS = ['Simple', 'Needs Confirmation', 'Needs Documents', 'Complex'];

// ─── 3-STAGE ELIGIBILITY ENGINE — Stage definitions & decision colour maps ───
// Used by EligibilityEngine section and LeadCard (decision badges).

export const STAGE1_CHECKS = [
  { key: 'no_strikeoff_notice', label: 'No final strike-off notice issued by ROC', source: 'MCA' },
  { key: 'no_stk2_filed', label: 'No STK-2 already filed', source: 'MCA Filings' },
  { key: 'no_msc1_filed', label: 'Not applied for Dormant status (MSC-1)', source: 'MCA Filings' },
  { key: 'not_dissolved', label: 'Not dissolved via amalgamation / arrangement', source: 'Legal' },
  { key: 'not_vanishing', label: 'Not classified as vanishing company', source: 'CIN + MCA' },
];

export const STAGE2_248_GROUNDS = [
  {
    key: 's248_1a', clause: 'Sec 248(1)-a',
    label: 'Company failed to commence business within one year of incorporation',
    indicators: 'AOC-4 first year, INC-20A absence',
    further_docs: ['Bank statements since incorporation', 'Board minutes on commencement', 'GST registration/returns', 'Income-tax returns'],
    note: 'If business actually commenced, this ground is not available.',
  },
  {
    key: 's248_1c', clause: 'Sec 248(1)-c',
    label: 'No business/operations for 2 preceding FYs & no dormant status (Sec 455)',
    indicators: 'AOC-4/XBRL last 2 FYs, MGT-7/7A, no STK/dormant forms',
    further_docs: ['Bank statements', 'GST returns', 'Invoices/agreements', 'Management declaration on non-operation'],
    note: 'Most common ground. Ensure "no business" is factually supportable.',
  },
  {
    key: 's248_1d', clause: 'Sec 248(1)-d',
    label: 'Subscribers not paid & INC-20A (Sec 10A) not filed within 180 days',
    indicators: 'INC-20A filing status, AOC-4 first year, bank statements',
    further_docs: ['Subscriber payment proofs', 'Board resolutions on receipt of capital', 'Subscriber confirmations'],
    note: 'Use only where genuinely applicable; conflicts with past filings create exposure.',
  },
  {
    key: 's248_1e', clause: 'Sec 248(1)-e',
    label: 'Not carrying on business per ROC physical verification (Sec 12(9))',
    indicators: 'ROC inspection report, MCA physical verification records',
    further_docs: ['ROC correspondence', 'Inspection reports', 'Proof of non-operation'],
    note: 'ROC-initiated basis. Use only where clear record under Sec 12(9) exists.',
  },
];

export const STAGE3_249_RESTRICTIONS = [
  {
    key: 's249_1a_name', clause: '249(1)(a)',
    label: 'Company has NOT changed its name in the 3 months preceding the application',
    indicators: 'MCA filings for RUN/INC-24, new COI',
    further_docs: ['Board/members resolutions on name change', 'ROC approval orders'],
    note: 'If name was changed within 3 months, defer application until cooling-off period is over.',
  },
  {
    key: 's249_1a_office', clause: '249(1)(a)',
    label: 'Company has NOT shifted registered office from one State to another in 3 months preceding',
    indicators: 'INC-23/INC-28/INC-22 filings, fresh COI',
    further_docs: ['NCLT/ROC orders for shifting', 'Lease documents for new premises'],
    note: 'If such shifting occurred, application is barred for 3 months.',
  },
  {
    key: 's249_1b', clause: '249(1)(b)',
    label: 'Company refrained from disposing property/rights outside normal course before cessation',
    indicators: 'Fixed-asset schedules in AOC-4, notes on sale of undertakings',
    further_docs: ['Sale deeds/conveyances', 'Board approvals', 'Valuation reports', 'Related-party transaction details'],
    note: 'Significant asset disposals prior to closure can bar strike-off and attract investigation.',
  },
  {
    key: 's249_1c', clause: '249(1)(c)',
    label: 'No activity in 3 months except: (i) making application, (ii) deciding on it, (iii) concluding affairs, (iv) statutory compliance',
    indicators: 'GST returns, bank statements, invoices, payroll records',
    further_docs: ['Contract review', 'HR records', 'Management declaration of cessation'],
    note: 'Any new business, fresh contracts, or trading in this period can bar the application.',
  },
  {
    key: 's249_1d', clause: '249(1)(d)',
    label: 'No compromise/arrangement application pending before NCLT which is not concluded',
    indicators: 'NCLT cause-list search, company law counsel report',
    further_docs: ['Copies of petitions/orders under Sec 230-232'],
    note: 'If such proceedings exist and are not concluded, Sec 248(2) application is prohibited.',
  },
  {
    key: 's249_1e', clause: '249(1)(e)',
    label: 'Company is NOT being wound up under Chapter XX or under IBC (CIRP/liquidation)',
    indicators: 'NCLT orders, MCA status (under liquidation/CIRP)',
    further_docs: ['Appointment orders of IRP/RP/Liquidator', 'Public announcements'],
    note: 'If under winding up or IBC, strike-off u/s 248(2) is not permissible.',
  },
];

export const DECISION_COLORS = {
  // New 3-state labels
  eligible_strikeoff: 'bg-emerald-100 text-emerald-800 border-emerald-300',
  eligible_pending_filings: 'bg-amber-100 text-amber-800 border-amber-300',
  not_eligible_strikeoff: 'bg-red-100 text-red-700 border-red-300',
  // Continue-intent badge (strike-off N/A, CCFS regularisation path)
  ccfs_regularisation: 'bg-violet-100 text-violet-800 border-violet-300',
  // Legacy mappings retained for backward compat on old saved leads
  direct_closure: 'bg-emerald-100 text-emerald-800 border-emerald-300',
  conditional_closure: 'bg-amber-100 text-amber-800 border-amber-300',
  complex_case: 'bg-red-100 text-red-700 border-red-300',
  not_eligible: 'bg-red-200 text-red-800 border-red-400',
  likely_eligible: 'bg-amber-100 text-amber-800 border-amber-300',
};

// Normalize any saved/legacy decision label into one of the allowed display labels
export const DISPLAY_DECISION_LABEL = {
  eligible_strikeoff: 'Eligible for Strike-off',
  eligible_pending_filings: 'Eligible with Pending Filings',
  not_eligible_strikeoff: 'Not Eligible for Strike-off',
  ccfs_regularisation: 'CCFS Eligible — Regularise',
  direct_closure: 'Eligible for Strike-off',
  conditional_closure: 'Eligible with Pending Filings',
  likely_eligible: 'Eligible with Pending Filings',
  complex_case: 'Not Eligible for Strike-off',
  not_eligible: 'Not Eligible for Strike-off',
};

export const SOURCE_COLORS = {
  MCA: 'bg-blue-50 text-blue-600',
  'MCA Filings': 'bg-blue-50 text-blue-600',
  'Filing Index': 'bg-blue-50 text-blue-600',
  'CIN + MCA': 'bg-violet-50 text-violet-600',
  Legal: 'bg-slate-100 text-slate-500',
  Regulatory: 'bg-slate-100 text-slate-500',
};
